import {useSelector} from 'react-redux';

import RemoteIconV2 from '@/components/Icon/RemoteIconV2';
import appContent from '@/services/content/appContent';
import connectivityService from '@/services/device/connectivityService';
import {selectIsHolderConnected} from '@/state/selectors/mw';
import {twx} from '@/utils/tailwindUtils';

const NoHolderBanner = ({className}) => {
    const isHolderConnected = useSelector(selectIsHolderConnected);
    const isUsb = connectivityService.isUsb();
    const noHolderBanner = isUsb ? appContent.getNoHolderUsbBanner() : appContent.getNoHolderBanner();
    const icon = isHolderConnected ? appContent.getHolderReconnectingBanner() : noHolderBanner;

    if (!icon) return null;

    const {title, description} = icon || {};

    return (
        <div
            className={twx('flex w-full items-center gap-2 rounded-xl bg-primary-dark-5 p-4 text-start', className)}
            role='status'
            aria-live='polite'
        >
            <RemoteIconV2 icon={icon} className='h-8 w-8' />
            <div>
                <h2 className='mb-0 text-16 font-bold'>{title}</h2>
                <p className='text-14 tracking-04'>{description}</p>
            </div>
        </div>
    );
};

export default NoHolderBanner;
